import * as React from 'react';
import classnames from 'classnames';
import './index.scss';
import Font from "@layout/Font";

interface Props {
    children?: React.ReactNode;
}

const PageTitle = (props: Props) => (
    <div className="page-title line-bottom">
        <Font font="primary" size={50}>
            { props.children }
        </Font>
    </div>
);

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/layout/PageTitle/index.tsx